import { ETruncation } from '../../../types';
import { isBuildingSuggest } from '../../../utils/types';
import * as styles from '../styles.css';
export var getSuggestionStyles = function getSuggestionStyles(item, selected) {
  var itemStyles = [styles['item'], selected && styles['item-selected']];
  if (isBuildingSuggest(item)) {
    itemStyles.push(styles['item-building']);
  }
  return itemStyles;
};

/**
 * Возвращает определенный css класс для укорачивания строки с добавлением "..."
 * Для укорачивания до 1й строки используется один подход, до 2х - другой
 * Параметр isInner определяет, для какого элемента (внешнего или внутреннего тега) происходит вызов этой функции
 * */
export function getTruncationCss() {
  var itemsTruncation = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : ETruncation.One;
  var isInner = arguments.length > 1 ? arguments[1] : undefined;
  if (itemsTruncation === ETruncation.One && isInner) {
    return isInner ? '' : styles['trunc_1'];
  }
  return styles[itemsTruncation];
}